import React from 'react';
import * as PropTypes from 'prop-types';
import styles from '../DerouleArmeComponent.module.scss';

const DerouleArmePersonneComponent = ({ personne }) => {
    const adresseRue =
        (personne.adresse.numeroVoie ? `${personne.adresse.numeroVoie} ` : '') +
        (personne.adresse.extension ? `${personne.adresse.extension} ` : '') +
        (personne.adresse.libelleVoie ? `${personne.adresse.libelleVoie} ` : '') +
        (personne.adresse.lieuDit ? `${personne.adresse.lieuDit} ` : '');

    const adresseVille =
        (personne.adresse.codePostal ? `${personne.adresse.codePostal} ` : '') +
        (personne.adresse.ville ? `${personne.adresse.ville} ` : '');

    const adressePays = personne.adresse.pays.libelle;

    return (
        <div className={styles['DerouleArme-element']}>
            <div className={styles['DerouleArme-labelElement']}>{personne.libelleRelation}</div>
            <div>
                {personne.categorieLibelle === 'Détenteur' ? 'Détenteur' : 'Raison Sociale'} :{' '}
                <span className={styles['DerouleArme-labelElement']}>
                    {personne.libellePersonne}
                </span>
            </div>
            <div>
                Numéro Sia :{' '}
                <span className={styles['DerouleArme-labelElement']}>{personne.numeroSia}</span>
            </div>
            <div>
                Catégorie :{' '}
                <span className={styles['DerouleArme-labelElement']}>
                    {personne.categorieLibelle}
                </span>
            </div>
            <div>Adresse :</div>
            <div className={styles['DerouleArme-labelElement']}>
                {adresseRue}
                <br />
                {adresseVille} {adressePays}
            </div>
        </div>
    );
};

DerouleArmePersonneComponent.defaultProps = {
    personne: null,
};

DerouleArmePersonneComponent.propTypes = {
    personne: PropTypes.shape({
        numeroSia: PropTypes.string,
        categorieLibelle: PropTypes.string.isRequired,
        libelleRelation: PropTypes.string.isRequired,
        libellePersonne: PropTypes.string.isRequired,
        adresse: PropTypes.shape({
            numeroVoie: PropTypes.string,
            extension: PropTypes.string,
            libelleVoie: PropTypes.string,
            lieuDit: PropTypes.string,
            codePostal: PropTypes.string,
            ville: PropTypes.string,
            pays: PropTypes.shape({
                libelle: PropTypes.string.isRequired,
            }).isRequired,
        }),
    }),
};

export default DerouleArmePersonneComponent;
